module.exports = __webpack_public_path__ + "9fb7d6f15294f4e2f97b088a5895962a.svg";